export function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  })[char] ?? char);
}

export function formatTime(ms: number | null | undefined): string {
  if (ms === null || ms === undefined || !Number.isFinite(ms) || ms < 0) return "—";
  const wholeMs = Math.floor(ms);
  const minutes = Math.floor(wholeMs / 60_000);
  const seconds = Math.floor((wholeMs % 60_000) / 1000);
  const centiseconds = Math.floor((wholeMs % 1000) / 10);
  return `${minutes}:${String(seconds).padStart(2, "0")}.${String(centiseconds).padStart(2, "0")}`;
}

export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("tr-TR", { day: "numeric", month: "short", year: "numeric" }).format(date);
}

export function initials(name: string): string {
  return name.trim().split(/\s+/).slice(0, 2).map((part) => [...part][0]?.toLocaleUpperCase("tr-TR") ?? "").join("") || "?";
}
